






























































































































import TabsInfoMixin from '../../devices/TabsInfoMixin';
import Component from 'vue-class-component';
import { Mixins } from 'vue-mixin-decorator';
import { Prop, Watch } from 'vue-property-decorator';
import { Reports, Global, Props } from '@/store';
import Utils from '@/modules/Utils';
import API, { Types } from '@/modules/API';
import config from '../../../map/map.config';
import PropEditor from '@/components/PropEditor.vue';
import ConfirmDialog from '@/components/dialogs/ConfirmDialog.vue';
import PropUtils from '@/modules/PropUtils';
import cloneDeep from 'lodash/cloneDeep';
import { i18n } from '@/main';
import { MetaDeviceBase } from '@/modules/Types';
import { DELIVERED_STATE, RETROFIT_STATE, PARTIAL_RETROFIT_STATE } from '@/modules/retrofitActions';

@Component({
  components: {
    PropEditor,
    ConfirmDialog
  }
})
class DeviceDataTab extends Mixins<TabsInfoMixin>(TabsInfoMixin) {
  @Global.State('readonly_user') readonly_user;
  @Global.State('lang') lang;
  @Reports.Getter('commissioned_map') commissioned_map;
  @Props.State('fixture_meta_device_options') fixture_meta_device_options;
  @Props.State('cabinet_meta_device_options') cabinet_meta_device_options;

  // @ts-ignore
  @Prop() device;
  @Prop() projectProperties;
  @Prop() metaDeviceData;
  @Prop() cabinetDevices;
  @Prop() updateMetaDeviceFields;
   
  formFieldsListHub = [];
  confirmDialog = false;
  deviceData: MetaDeviceBase = {};
  estimated_address = false;
  loading = true;
  lengthRules = [
    (v) => !!v || i18n.t('Required field'),
    (v) => (v && v.length <= 50) || 'Max field length is 50 characters'
  ];
  optional_cabinet_id_options = [];
  devices_id_options = [];
  cabinets_id_options = [];
  search = '';
  new_cabinet_message = `I know that this ID doesn't exist in the system and I'm responsible for the consequences`;
  show_new_message = false;
  prop_utils = PropUtils;
  description_field = null;
  $refs!: { 
    propEditor: InstanceType<typeof PropEditor>,
    form: Vue & { validate: () => boolean; resetValidation: () => void };
  };

  mounted() {
    this.loading = true;
    this.loadFields();
    this.loading = false;
  }

  loadFields() {
    const form_meta_device_hub = this.projectProperties.find((el) => el.name === 'dashboard.form_meta_device_hub');
    this.formFieldsListHub = form_meta_device_hub ? form_meta_device_hub['value']['fields'] : [];
    this.formFieldsListHub = this.formFieldsListHub.filter((field) => field.name !== 'cabinet_type');
    this.setCabinetIdOptions();
    this.deviceData = cloneDeep(this.metaDeviceData);

    if (this.formFieldsListHub) {
      const address_field = this.formFieldsListHub.find((field) => field.name === 'cabinet_address');
      if (address_field){
        this.estimated_address = !this.metaDeviceData['cabinet_address'] && this.metaDeviceData.estimated_address;
        this.deviceData['cabinet_address'] = this.metaDeviceData['cabinet_address'] || this.metaDeviceData.estimated_address || '';
      }
      this.description_field = this.formFieldsListHub.find((field) => field.name === 'description');
    }
  }

  /**
   * Operational / Retrofit / Partial Retrofit put this form into restricted editing mode:
   * a cabinet that is live or out for Retrofit shouldn't have its details rewritten
   * wholesale. Any other state (Installing) leaves editing exactly as it was.
   *
   * Read off the device row, the single source of truth for the operation state.
   */
  get is_restricted_state(){
    const operation_state = Utils.getOperationState(this.device);
    return [DELIVERED_STATE, RETROFIT_STATE, PARTIAL_RETROFIT_STATE].includes(operation_state);
  }

  /** Form-wide lock, for the controls that have no field config of their own (Notes). */
  get readonly(){
    return this.readonly_user || this.is_restricted_state;
  }

  /**
   * Whether a configured field is locked.
   *
   * `readonly: true` always wins. Otherwise, a restricted state locks the field unless the
   * config opts it back in with `editable_in_restricted_state: true` - the flag is optional
   * and absence means false, so configs written before it existed keep every field locked
   * in these states, which is what the blanket lock did before.
   *
   * Which fields stay editable is therefore entirely up to
   * `dashboard.form_meta_device_hub`; nothing is listed here.
   */
  isFieldReadonly(field){
    if (this.readonly_user) return true;
    if (!field) return this.is_restricted_state;
    if (field['readonly']) return true;

    return this.is_restricted_state && field['editable_in_restricted_state'] !== true;
  }

  // Reports/buildMetaDeviceOptions builds these after the project-wide stream completes,
  // and then only on an idle callback - long after this tab mounts. Copying them once in
  // loadFields() therefore captured an empty list and never looked again, which is what
  // made a saved id look unknown. Both filter components that read this state watch it
  // for the same reason (see MapFilter / MetaDeviceFilter).
  @Watch('fixture_meta_device_options')
  @Watch('cabinet_meta_device_options')
  setCabinetIdOptions(){
    this.devices_id_options = this.fixture_meta_device_options.cabinet_id || [];
    this.cabinets_id_options = this.cabinet_meta_device_options.cabinet_id || [];

    this.optional_cabinet_id_options = this.devices_id_options.filter((cabinet_id) => !this.cabinets_id_options.includes(cabinet_id));
    this.optional_cabinet_id_options.sort((c1, c2) => c1.localeCompare(c2, undefined, {numeric: true, sensitivity: 'base'}));

    // The warning was computed against the stale list, so re-evaluate it against the
    // fresh one instead of leaving a message on screen that no longer holds.
    if (this.search) this.show_new_message = this.checkUniqueId() === true && this.checkNewCabinetID();
  }

  checkIsRequired(field) {
    // A locked field can't be filled in, so it must not be marked mandatory either.
    return field.mandatory && !this.isFieldReadonly(field);
  }

  mandatoryCheck(field_name, mandatory){
    return mandatory ? !!this.deviceData[field_name] || this.$t('Required field') : true;
  }

  checkUniqueId(){
    return !this.deviceData['cabinet_id']
      ? this.$t('Required field')
      : this.cabinets_id_options.includes(this.deviceData['cabinet_id']) &&
        this.metaDeviceData['cabinet_id'] !== this.deviceData['cabinet_id']
        ? this.$t(`Cabinet with same id already exists`)
        : true;
  }

  getTextfieldLabel(field){
    return field.name === 'cabinet_address'
      ? `${this.$t(`${PropUtils.getFieldLowerToUpper(field.name)}`)}${this.estimated_address && `(${this.$t('Estimated')})` || ''}${this.checkIsRequired(field) && '*' || ''}`
      : `${this.$t(`${PropUtils.getFieldLowerToUpper(field.name)}`)}${this.checkIsRequired(field) && '*' || ''}`;
  }

  @Watch('search')
  updateCabinetID(){
    this.deviceData['cabinet_id'] = this.search;
    this.show_new_message = this.checkUniqueId() === true && this.checkNewCabinetID();
  }

  /**
   * "This id isn't used by any fixture or cabinet in the project". The option lists are
   * the only evidence for that claim, so it can't be made when they're unavailable:
   *
   * - Empty lists mean "not loaded", not "nothing exists". The watcher above covers the
   *   map, where they arrive late, but Cabinet Details never runs the project-wide stream
   *   that builds them at all, so there they stay empty for the page's lifetime.
   * - The device's own saved id can be missing from a *populated* list too:
   *   buildMetaDeviceOptions only collects ids from commissioned cabinets, and
   *   optional_cabinet_id_options deliberately excludes ids already taken by a cabinet.
   *   An id saved on this very device is in the system by definition.
   */
  checkNewCabinetID(){
    if (!this.devices_id_options.length && !this.cabinets_id_options.length) return false;

    const saved_id = this.metaDeviceData['cabinet_id'];
    if (saved_id && `${this.search}` === `${saved_id}`) return false;

    return !this.optional_cabinet_id_options.includes(this.search) && !this.cabinets_id_options.includes(this.search);
  }

  numberRules(item) {
    return item['mandatory'] ?
      [
        (v) =>  !v ? this.$t('Required field') :
          (!isNaN(parseFloat(v)) &&
            v >= item['range']['min'] &&
            v <= item['range']['max']) ||
          `${this.$t('Number has to be between')} ${item['range']['min']} ${this.$t('and')} ${item['range']['max']}`
      ] :
      [
        (v) => !v ||
          (!isNaN(parseFloat(v)) &&
            v >= item['range']['min'] &&
            v <= item['range']['max']) ||
          `${this.$t('Number has to be between')} ${item['range']['min']} ${this.$t('and')} ${item['range']['max']}`
      ];
  }

  async setCurrentLocation() {
    const data: any = await Utils.getCurrentPosition();
    if (data && data.coords) {

      try {
        const { latitude, longitude } = data.coords;
        let GEODATA;
        const response = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${Number(
            latitude
          )},${Number(longitude)}&key=${config.TOKEN_GOOGLE}`
        );
        if (response.ok) {
          const json = await response.json();
          if (json.error_message) {
            throw new Error(json.error_message);
          }
          GEODATA = json.results[0] && json.results[0].formatted_address;
          this.deviceData.address = GEODATA;
          this.$forceUpdate();
        } else {
          throw new Error();
        }
      } catch (error) {
        console.log('error in converting address', error);
        this.deviceData['address'] = 'Unknown location';
      }
    }
  }

  checkFormValidation(){
    try {
      if (this.$refs.form.validate()) {
        this.confirmDialog = true;
      }else {
        this.$notify({
          type: 'error',
          title: 'Warning',
          text: 'Please fullfill all required fields'
        });
      }
    } catch (error) {
      console.log('ERROR WHILE VALIDATE DATA:', error);
    }
  }

  updateDeviceProperty() {
    const prop = {
      name: 'meta.device',
      objectID: this.device.id,
      objectType: Types.DEVICES
    };

    if (this.formFieldsListHub.some((field) => field.name === 'cabinet_id') && typeof this.deviceData['cabinet_id'] !== 'string'){
      this.deviceData.cabinet_id = this.deviceData.cabinet_id.value;
    }

    Object.entries(this.deviceData).forEach(([field, value]) => this.deviceData[field] = Utils.removeLeadingZeroesAndSpaces(value));

    this.$refs.propEditor.save(
      this.deviceData,
      prop,
      () => {
        if (this.show_new_message || !this.cabinets_id_options.includes(this.deviceData['cabinet_id'])) {
          this.updateCurrentOptions();
          this.updateSearchProperty();
          this.show_new_message = false;
        }
        // Commit through Vuex so that pre-computed __iconKey is refreshed and the
        // map updates: editDeviceField recomputes the cabinet's own icon and cascades
        // a recompute to all of its fixtures (their icons depend on cabinet meta.device).
        this.$store.commit('Reports/editDeviceField', {
          device_id: this.device.id,
          name: 'meta.device',
          value: this.deviceData
        });
        this.$emit('dataChanged', this.deviceData);
        this.updateMetaDeviceFields(this.deviceData);
      },
      'All changes have been saved successfully'
    );
    this.confirmDialog = false;
  }

  updateCurrentOptions(){
    this.cabinets_id_options.push(this.deviceData['cabinet_id']);
    this.cabinets_id_options = this.cabinets_id_options.filter((cabinet_id) => cabinet_id !== this.metaDeviceData['cabinet_id']);
    this.optional_cabinet_id_options = this.devices_id_options.filter((cabinet_id) => !this.cabinets_id_options.includes(cabinet_id));
    this.optional_cabinet_id_options.sort((c1, c2) => c1.localeCompare(c2, undefined, {numeric: true, sensitivity: 'base'}));
  }

  updateSearchProperty(){
    const cabinet_id_options = this.cabinet_meta_device_options.cabinet_id;
    const prev_id_index = cabinet_id_options.indexOf(this.metaDeviceData['cabinet_id']);
    cabinet_id_options.splice(prev_id_index, 1, this.deviceData['cabinet_id']);
  }
}

export default DeviceDataTab;
